import { Navigate, Route, Routes } from 'react-router-dom'
import { ProtectedRoute } from './components/ProtectedRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Clients from './pages/Clients'
import ClientForm from './pages/ClientForm'
import Reports from './pages/Reports'
import ReportDetail from './pages/ReportDetail'
import ChatClient from './pages/ChatClient'
import OpenActions from './pages/OpenActions'
import OpenActionsByWeek from './pages/OpenActionsByWeek'
import OpenManagerAnalyses from './pages/OpenManagerAnalyses'
import Impact from './pages/Impact'
import Leaderboard from './pages/Leaderboard'
import WeeklyPlanning from './pages/WeeklyPlanning'
import Users from './pages/Users'
import Settings from './pages/Settings'
import ManagerActivity from './pages/ManagerActivity'
import Trends from './pages/Trends'
import ReportErrors from './pages/ReportErrors'
import Intelligence from './pages/Intelligence'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="placar" element={<Leaderboard />} />
        <Route path="clients" element={<Clients />} />
        <Route
          path="clients/new"
          element={
            <ProtectedRoute adminOnly>
              <ClientForm />
            </ProtectedRoute>
          }
        />
        <Route path="clients/chat" element={<ChatClient />} />
        <Route path="intelligence" element={<Intelligence />} />
        <Route path="clients/:id" element={<ClientForm />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports/:id" element={<ReportDetail />} />
        <Route path="open-actions" element={<OpenActions />} />
        <Route path="open-actions-by-week" element={<OpenActionsByWeek />} />
        <Route path="open-analyses" element={<OpenManagerAnalyses />} />
        <Route path="impact" element={<Impact />} />
        <Route path="planning" element={<WeeklyPlanning />} />
        <Route path="trends" element={<Trends />} />
        <Route
          path="users"
          element={
            <ProtectedRoute adminOnly>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="manager-activity"
          element={
            <ProtectedRoute adminOnly>
              <ManagerActivity />
            </ProtectedRoute>
          }
        />
        <Route
          path="report-errors"
          element={
            <ProtectedRoute adminOnly>
              <ReportErrors />
            </ProtectedRoute>
          }
        />
        <Route
          path="settings"
          element={
            <ProtectedRoute adminOnly>
              <Settings />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
